import './linkarrow.less'

import {m} from '@codeurs/front'
import {ArrowIcon} from 'assets/inline-icons'
import {FunctionComponent} from 'react'
import {style} from 'util/style'

export const LinkArrow: FunctionComponent<{
	mod?: 'blue'
}> = ({mod, ...rest}) => {
	const styles = style('linkarrow')
	return (
		<span class={styles('container').mergeProps(rest)}>
			<ArrowIcon className={styles.mod(mod)} />
		</span>
	)
}
